"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _actions = require('web/actions');

/* One entry in the first-time tutorial queue: a popup, tooltip or snackbar,
 * looked up by `id`. pushInteractablesQueue fills in a missing id, and every
 * caller passes a type. */



















const initialState = {
  interactablesQueue: [],
}

 const selectActiveInteractable = (
  state,
) =>
  state.firstTimeTutorial.interactablesQueue[0]; exports.selectActiveInteractable = selectActiveInteractable

exports. default = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case _actions.types.PUSH_INTERACTABLES_QUEUE:
      return {
        ...state,
        // SAFETY: pushInteractablesQueue always dispatches an array of
        // interactables with ids.
        interactablesQueue: (action.payload ).concat(state.interactablesQueue),
      }
    case _actions.types.DISMISS_INTERACTABLE_BY_ID: {
      // SAFETY: the payload dismissInteractableById dispatches.
      const payload = action.payload 
      return {
        ...state,
        interactablesQueue: state.interactablesQueue.filter(
          x => x.id !== payload.id,
        ),
      }
    }
    case _actions.types.SET_INTERACTABLE_PERMISSION: {
      // SAFETY: the payload permitInteractable dispatches.
      const payload = action.payload 
      return {
        ...state,
        interactablesQueue: state.interactablesQueue.map(x =>
          x.id === payload.id
            ? { ...x, isPermitted: payload.isPermitted }
            : x,
        ),
      }
    }
  }
  return state
}
